// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentIssue_wrapper","textColumnTitle":"PaymentIssue_textColumnTitle","textColumnPara":"PaymentIssue_textColumnPara"};